import AttioIcon from "../../assets/components/sources/AttioIcon";

const AttioLogomark = ({ height }: { height: number }) => {
  return <AttioIcon height={height} />;
};

export default AttioLogomark;
